import { Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogClose,
} from '@angular/material/dialog';
import {
  UserDataTableItem,
  UsersService,
} from 'src/app/services/users/users.service';
import { PayeePopupComponent } from '../../../../shared/payee-popup/payee-popup.component';
import { PayeeButtonComponent } from '../../../../shared/payee-buttons/payee-button/payee-button.component';

@Component({
  selector: 'app-delete-user-dialog',
  templateUrl: './delete-user-dialog.component.html',
  styleUrls: ['./delete-user-dialog.component.scss'],
  imports: [PayeePopupComponent, PayeeButtonComponent, MatDialogClose],
})
export class DeleteUserDialogComponent {
  private dialogRef =
    inject<MatDialogRef<DeleteUserDialogComponent, boolean>>(MatDialogRef);
  private usersService = inject(UsersService);

  data = inject<UserDataTableItem>(MAT_DIALOG_DATA);

  loading = false;

  async submit(): Promise<void> {
    try {
      this.loading = true;

      await this.usersService.deleteUser(this.data.user_uuid);

      this.dialogRef.close(true);
    } catch (error) {
      console.error('Error while deleting user', error);
    } finally {
      this.loading = false;
    }
  }
}
